import { FC, Fragment } from "react";
import { Form } from "react-bootstrap";
import InputMask from "react-input-mask";

interface AdditionalProps {
  formik: any;
}
interface GenericMaskInputProps extends AdditionalProps {
  type: string;
  name: string;
  label: string;
  disabled: boolean;
  mask: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // optional
}

const digitsOnly = (s: string) => s.replace(/\D+/g, "");

const GenericMaskInput: FC<GenericMaskInputProps> = ({
  formik,
  type,
  name,
  label,
  disabled,
  mask,
  onChange,
}) => {
  const valueRaw: string = formik.values?.[name] ?? ""; // stored as digits only
  const error = formik.touched?.[name] && formik.errors?.[name];

  return (
    <Fragment>
      <Form.Label htmlFor={name} className="mb-1 fw-normal">
        {label}
      </Form.Label>
      <Form.Control
        id={name}
        name={name}
        type={type}
        as={InputMask}
        mask={mask}
        value={valueRaw}
        maskChar={null}
        alwaysShowMask={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const raw = digitsOnly(e.target.value);
          formik.setFieldValue(name, raw);
          onChange?.({
            ...e,
            target: { ...e.target, name, value: raw },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        onBlur={() => formik.setFieldTouched(name, true)}
        disabled={disabled}
        className={`${error ? "is-invalid" : ""} mb-2`}
      />
      <Form.Control.Feedback type="invalid">
        {error as string}
      </Form.Control.Feedback>
    </Fragment>
  );
};

export default GenericMaskInput;
